<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-card
      class="mx-auto small-page-width"
    >
      <v-card-title>
        {{ $t('page_not_found') }}
      </v-card-title>
      <v-divider />
      <v-card-actions>
        <v-btn
          :to="{ name: 'server.index' }"
          color="secondary"
          exact
          text
        >
          {{ $t('go_to_homepage') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'PageNotFoundView',

  metaInfo () {
    return {
      meta: [
        {
          content: 'noindex',
          name: 'robots',
        },
      ],
      title: this.$t('page_not_found'),
    }
  },
}
</script>
